@if (icon) {
  <mat-icon class="icon text-black" [svgIcon]="icon"></mat-icon>
}
@if (title) {
  <h1 class="text-black">{{ title }}</h1>
}
@if (link && linkDescription) {
  <a class="text-link" [routerLink]="link">{{ linkDescription }}</a>
}
